export default "__VITE_ASSET__hBMUKNcd__"